import { TemplateDirective } from '@fleet-beat/core';
import { Observable } from 'rxjs';

export const enum AnexType {
  None = 'none',
  Icon = 'icon',
  Template = 'template',
  Text = 'text',
}

export type AnexConfig = EmptyAnexConfig | IconAnexConfig | TextAnexConfig | TemplateAnexConfig;

export interface EmptyAnexConfig {
  type: AnexType.None;
}

export interface IconAnexConfig {
  type: AnexType.Icon;
  iconName: string;
  outlined?: boolean;
  custom?: boolean;
}

export interface TextAnexConfig {
  type: AnexType.Text;
  text: string;
}

export interface TemplateAnexConfig {
  type: AnexType.Template;
  templateName?: string;
  template$?: Observable<TemplateDirective<object>>;
}
